module.exports = __webpack_public_path__ + "img/logo_whrite.a4f3bad4.png";